import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. Reads has_business_profile from the parent-fetched
// get_setup_progress snapshot. True when all 5 canonical fields (name, address,
// city, province, phone) are non-null.
//
// Finding: the pre-§1.1 resolver accepted email as an alternative to phone.
// Decision #412 locks the canonical five to phone-required. Email alone no
// longer satisfies the profile check.
export async function resolveBusinessProfileItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_business_profile) return { complete: true, reason: 'has profile' };
  return { complete: false, reason: 'missing profile fields' };
}
